import type { ElementType, ReactNode } from 'react';

export interface ShimmerProps {
  /** Element to render. Defaults to a span so it can sit inside a line of text. */
  as?: ElementType;
  /** Navy carries a gold sweep; gold is the reverse for credit lines. */
  tone?: 'navy' | 'gold';
  className?: string;
  children: ReactNode;
}

/**
 * Animated loading text. Motion is disabled by the reduced-motion rule on
 * `.text-shimmer`, which leaves the text fully visible.
 */
export function Shimmer({ as: Tag = 'span', tone = 'navy', className = '', children }: ShimmerProps) {
  return (
    <Tag className={`text-shimmer${tone === 'gold' ? ' text-shimmer--gold' : ''} ${className}`.trim()}>
      {children}
    </Tag>
  );
}
